import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../translation/translation_container';
import TextInput from '../form/floating_label/text_input';
import Submit from '../form/floating_label/submit';
import Translation from '../translation/translation';
import Select from '../form/floating_label/select';
import { isNzStore } from '../../../_views/configurator/common';
import VehicleConfiguratorButton from '../configurator_buttons/vehicle_configurator';
import MotoTyreSizeConfiguratorButton from '../configurator_buttons/moto_tyre_size_configurator';
import TyreSizeConfiguratorButton from '../configurator_buttons/tyre_size_configurator';
import CantProvideVehicle from '../configurator/cant_provide_vehicle';

function InputLayer(props) {
  const { filters, onChange, isCheckoutConfigurator, isRegoLookupV2, onChangeCantProvideVehicle, fromTyreSize } = props;
  const submitContainerClassNames = [
    'rego-lookup-configurator-submit-section',
    'rego-lookup-configurator-input-section',
  ];
  const submitDisabled = !filters.state || !filters.registration;
  const inputRegClass = isNzStore(TYROOLA.globals.store) ? ['input-uppercase', 'fullsize'] : ['input-uppercase'];
  return (
    <span>
      <div className="rego-lookup-configurator-input-layer-header">
        {!isRegoLookupV2 && <Translation translationKey={'rego-lookup-input-layer-header-text'} />}
        {isRegoLookupV2 && <Translation translationKey={'rego-lookup-input-layer-header-text-v2'} />}
      </div>
      <div className="rego-lookup-configurator-input-layer-sub-header">
        {!isRegoLookupV2 && <Translation translationKey={'rego-lookup-input-layer-content-text'} />}
        {isRegoLookupV2 && <Translation translationKey={'rego-lookup-input-layer-content-text-v2'} />}
      </div>
      <form
        className="rego-lookup-input-layer rego-lookup-configurator-section"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="rego-lookup-section rego-lookup-input-section">
          {props.inputStateVisible && (
            <TranslationContainer
              targetProperties={{
                label: { translationKey: 'rego-lookup-input-layer-input-state-label' },
              }}
            >
              <Select
                name="state"
                value={filters.state}
                hasValue={filters.state && filters.state.length > 0}
                options={props.stateOptions}
                onChange={onChange}
                label="will-be-replaced"
                highlight={true}
                loading={false}
                invalid={false}
                required={true}
                disabled={false}
                additionalClassNames={['select-state']}
              />
            </TranslationContainer>
          )}
          <TranslationContainer
            targetProperties={{
              label: { translationKey: 'rego-lookup-input-layer-input-registration-label' },
            }}
          >
            <TextInput
              name="registration"
              value={filters.registration}
              onChange={props.onChange}
              label="will-be-replaced"
              highlight
              disabled={false}
              maxLength="8"
              invalid={props.registrationInvalid}
              additionalClassNames={inputRegClass}
              onBlur={props.onBlur}
            />
          </TranslationContainer>
        </div>

        <div className={submitContainerClassNames.join(' ')}>
          <TranslationContainer targetProperty="label" translationKey="rego-lookup-input-layer-button-continue-label">
            <Submit
              onSubmit={props.onSubmit}
              label="will-be-replaced"
              call-to-action={true}
              disabled={submitDisabled}
            />
          </TranslationContainer>
        </div>

        <div className="rego-lookup-configurator-input-layer-confirmation-info-alternative">
          <p>
            <Translation translationKey={'catalog-configurator-default-layer-or-shop-by'} />
          </p>
          <div className="configurator-alternative-container">
            <VehicleConfiguratorButton isVisibleV2={isRegoLookupV2} fromTyreSize={fromTyreSize} />
            {!isCheckoutConfigurator && <TyreSizeConfiguratorButton />}
            {!isCheckoutConfigurator && props.configuratorMotoTyreEnabled && <MotoTyreSizeConfiguratorButton />}
          </div>
        </div>

        {isCheckoutConfigurator && (
          <CantProvideVehicle
            id="cant-provide-vehicle-rego-input-layer"
            onChangeCantProvideVehicle={onChangeCantProvideVehicle}
          />
        )}
      </form>
      <div className="rego-lookup-input-layer-not-found">
        {props.licenceNotFound && <Translation translationKey={'rego-lookup-input-layer-not-found-message'} />}
        {props.licenceNotFound && (
          <Translation translationKey={'rego-lookup-input-layer-not-found-message-try-again'} onClick={props.onRetry} />
        )}
        {props.licenceNotFound && (
          <Translation translationKey={'rego-lookup-input-layer-not-found-message-open-vehicle-configurator'} />
        )}
      </div>
    </span>
  );
}

InputLayer.propTypes = {
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  registrationInvalid: PropTypes.bool.isRequired,
  licenceNotFound: PropTypes.bool.isRequired,
  buttonContinueDisabled: PropTypes.bool.isRequired,
  inputStateVisible: PropTypes.bool.isRequired,
  onRetry: PropTypes.func.isRequired,
  stateOptions: PropTypes.array.isRequired,
  configuratorMotoTyreEnabled: PropTypes.bool,
};

InputLayer.defaultProps = {
  configuratorMotoTyreEnabled: false,
};

export default InputLayer;
